<template>
  <iframe
    ref="soliqIframe"
    class="iframe"
    src="https://my3.soliq.uz/individual/cabinet/find-tin/home"
  ></iframe>
</template>

<script>
export default {
  methods: {
    // resizeIframe() {
    //   const iframe = this.$refs.soliqIframe;
    //   iframe.style.height =
    //     iframe.contentWindow.document.body.scrollHeight + "px";
    // },
  },
  mounted() {
    // const iframe = this.$refs.soliqIframe;
    // const iframeWindow = iframe.contentWindow;
    // const iframeDocument = iframe.contentDocument;
    // // Add a style tag to the iframe's document
    // const styleTag = iframeDocument.createElement("style");
    // styleTag.innerHTML = `
    //   div {
    //     display:none!important;
    //   }
    // `;
    // iframeDocument.head.appendChild(styleTag);
  },
};
</script>

.conditionals {
  & > li {
    cursor: pointer;
    padding: 6px 0;
    border-bottom: 1px solid #ebebeb;

    &:last-child {
      border-bottom: 1px solid #fff;
    }

    display: flex;
    align-items: center;

    & h6 {
      font-size: 12px;
      margin: 0 10px;

      &:last-child {
        margin-left: auto;
      }

      &:first-child {
        margin-right: 100px;
        margin-left: 0;
        min-width: 118px;
      }
    }
  }
}
</style>
